module.exports = __webpack_public_path__ + "img/norway-diseases-of-the-nervous-system-female.1a766b08.png";